import { Skeleton } from "@/app/components/shadcn/skeleton";

const ReviewProductCardSkeleton = () => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex gap-4">
        {/* Image Skeleton */}
        <Skeleton className="w-24 h-32 shrink-0 rounded-lg" />
        
        {/* Content Skeleton */}
        <div className="flex-1 flex flex-col min-w-0 space-y-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
          <div className="flex gap-1">
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-6 w-16" />
          </div>
          <Skeleton className="h-3 w-24" />
          <div className="flex-1" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-3 w-16" />
          <div className="flex gap-2 mt-2">
            <Skeleton className="h-10 flex-1" />
            <Skeleton className="h-10 flex-1" />
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewProductCardSkeleton;